<div class="wrap-help-page-banner pt10" @click="click()"><div class="f fh"><span class="bold pb8">{{ text }}</span></div></div>